import {MaxTariff} from '@yandex-taxi/js-integration-api'
import React from 'react'

import {useConfig} from 'src/config'

import {sortTariffs} from '../../../shared/utils'
import {Tariffs} from '../tariffs'

type Props = {
  tariffs: MaxTariff[]
}

const ZoneInfo: React.FC<Props> = ({tariffs}) => {
  const {availableTariffs} = useConfig().initialProps
  const sortedTariffs = sortTariffs(availableTariffs, tariffs || [])

  return <Tariffs tariffs={sortedTariffs} />
}

export default ZoneInfo
